import type { ReactNode } from "react";
import { YandexMetricaProvider } from "../../lib/next-yandex-metrica";

export default function ThirdPartyMetricaProvider({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <YandexMetricaProvider
      tagID={103551128}
      initParameters={{
        clickmap: false,
        webvisor: false,
        accurateTrackBounce: true,
        trackLinks: true,
      }}
      strategy="lazyOnload"
      router="pages"
    >
      {children}
    </YandexMetricaProvider>
  );
}
